import { useState, useEffect, useContext } from 'react';
import {  usePreferenceSearch } from '@sentara-health/sentara-api-hooks-core';
import { EmailPaperless, ProfileHeaderContent } from 'templates';
import { GlobalContext } from 'context';
import { useTranslation } from 'react-i18next';
import {
  Address,
  userAddressTypeHome,
  Phone,
  getDataByAddressType,
  ApiWrapper,
  formatePhoneNo
} from 'common';
import { Headings, Loader } from '@sentara-health/optimahealth_web';

const MemberProfile = () => {
  //Initialize translation hook
  const { t } = useTranslation();
  const { fetchPreferenceSearch } = usePreferenceSearch();
  const [userAddress, setUserAddress] = useState<Address[]>([]);
  const [userPhone, setUserPhone] = useState<Phone[]>([]);
  const { getFeature, loginMemberId, proxyMemberId } =
    useContext(GlobalContext);
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState<any>({});
  const {
    data: profileResponse,
    apiError: profileError,
    callApi,
  } = ApiWrapper(fetchPreferenceSearch);
  useEffect(() => {
    if (getFeature?.AccountSettings !== undefined) {
      let data = {
        memberId: btoa(loginMemberId),
      };
      setLoader(true);
      callApi(data, proxyMemberId, getFeature?.AccountSettings);
    }
  }, [loginMemberId, getFeature?.AccountSettings]);

  useEffect(() => {
    if (profileError) {
      setLoader(false);
    } else if (profileResponse) {
      setState(profileResponse);
      setLoader(false);
    }
  }, [profileResponse, profileError]);

  

  useEffect(() => {
    (async () => {
      getDataByAddressType(
        state?.address,
        userAddressTypeHome,
        setUserAddress
      );
      getDataByAddressType(
        state?.phones,
        userAddressTypeHome,
        setUserPhone
      );
    })();
  }, [state?.address]);

  return (
    <>
      {loader && <Loader />}
      <div className="enroll_in_benefits black-color">
        <div className="mb-4">
          <Headings
            level={1}
            text={t('common.memberProfiletitle')}
            variant="semiBold"
            data-testid="enrollBenefitsHeader"
          />
        </div>

        {/* To display the Home Address */}
        <div className="border border-clr border_radius_18 p-4 mb-4">

            {/* To display the phone number */}
            <div className="mb-3 pt-3">
              <ProfileHeaderContent
                header={t('common.primaryPhoneNumber')}
                contentOne={formatePhoneNo(userPhone[0]?.phoneNumber ?? '')}
                dataTestIdOne="profileName"
                contentClassNameOne={'_disabled mb-2'}
              />
            </div>
            
            {/* To display the Email Address */}
            <EmailPaperless
              state={state}
              setState={setState}
              memberView={true}
            />
        </div>
      </div>
    </>
  );
};

export default MemberProfile;
